import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

export type GiftAnimationProps = {
  type: 'sent' | 'received'
  giftId: number
  giftImg?: string
  giftName?: string
}

// must be enclosed in a div with class Modal (see SendGiftModal)
const GiftAnimation = ({
  type,
  giftId,
  giftImg,
  giftName,
}: GiftAnimationProps) => {
  const { t } = useTranslation()

  return (
    <Fragment>
      <div className="SendGiftModal__wrapper--success">
        <div className="SendGiftModal__wrapper__background"></div>
        <div>
          <img src={giftImg} />
        </div>
        <div>
          {type === 'sent'
            ? `${t('gift.is_sent', { gift: giftName })}`
            : `${t('gift.is_received', { gift: giftName })}`}
        </div>
      </div>
    </Fragment>
  )
}

export default GiftAnimation
